// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as DriverRepoConfig from "./DriverRepoConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as UrlUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as FilterPartnerRequestEncoder from "../../../view/components/components/filter-partners/FilterPartnerRequestEncoder.bs.js";

function fetchDriver(msisdn, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/administrators/" + (msisdn + "/basic_info"));
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(DriverRepoConfig.DriverProfileResponseConverter.execute, result);
                        });
            });
}

function fetchPartnerDocuments(uuid, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/document/report/crm?driver_uuid=" + uuid);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(DriverRepoConfig.PartnerDocumentResponseConverter.execute, result);
                        });
            });
}

function fetchPartnerWaitlistInfo(msisdn, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/crm/drivers/" + msisdn + "/active_waitlisting");
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(DriverRepoConfig.PartnerWaitlistResponseConverter.execute, result);
                        });
            });
}

function fetchPartnerOnboardingInfo(msisdn, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/crm/drivers/" + msisdn + "/onboarding_report");
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(DriverRepoConfig.PartnerOnboardingResponseConverter.execute, result);
                        });
            });
}

function fetchFilterDrivers(request, offset, country) {
  var urlParams = FilterPartnerRequestEncoder.appendRequestUrlParams(request);
  Belt_Option.mapWithDefault(offset, undefined, (function (offset_str) {
          urlParams["offset"] = offset_str;
          
        }));
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/administrators/filter_drivers_crm.json", urlParams);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(DriverRepoConfig.FilterDriverResponseConverter.execute, result);
                        });
            });
}

var DriverRepo = {
  fetchDriver: fetchDriver,
  fetchPartnerDocuments: fetchPartnerDocuments,
  fetchPartnerWaitlistInfo: fetchPartnerWaitlistInfo,
  fetchPartnerOnboardingInfo: fetchPartnerOnboardingInfo,
  fetchFilterDrivers: fetchFilterDrivers
};

export {
  DriverRepo ,
  
}
/* Config Not a pure module */
